import Flickity from 'flickity';

export default {
  init() {
  },
  finalize() {
    const $lightboxTriggers = $('.global-lightbox-open');
    const $globalLightboxWraps = $('.global-lightbox-wrap');

    function setLightboxImage($lightboxWrap) {
      const currentIndex = $lightboxWrap.data('current-index');

      $globalLightboxWraps.data('carousel').select(currentIndex);

      // Set image
      $lightboxWrap.find('.global-lightbox-images .global-lightbox-image').each(function() {
        if ($(this).data('index') == currentIndex) {
          $(this).removeClass('d-none');
        } else {
          $(this).addClass('d-none');
        }
      });

      // Set caption
      $lightboxWrap.find('.global-lightbox-caption').each(function() {
        if ($(this).data('index') == currentIndex) {
          $(this).removeClass('d-none');
        } else {
          $(this).addClass('d-none');
        }
      });

      // Set gallery item
      $lightboxWrap.find('.global-lightbox-images-carousel-image-button').each(function() {
        if ($(this).data('index') == currentIndex) {
          $(this).parent().addClass('active');
        } else {
          $(this).parent().removeClass('active');
        }
      });
    }

    function openLightbox($lightboxWrap) {
      $lightboxWrap.addClass('open');
      $('body').addClass('overflow-hidden');
      setLightboxImage($lightboxWrap);
    }

    $globalLightboxWraps.each(function() {
      const $theWrap = $(this);

      // Gallery image carousel
      const galleryCarousel = new Flickity($theWrap.find('.global-lightbox-images-carousel').get()[0], {
        adaptiveHeight: true,
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
          },
        },
      });

      // Pass the carousel to the element
      galleryCarousel.select($(this).data('index'));
      $theWrap.data('carousel', galleryCarousel);
      
      // Changing image based on gallery
      $theWrap.find('.global-lightbox-images-carousel-image-button').on('click', function() {
        $theWrap.data('current-index', $(this).data('index'));
        setLightboxImage($theWrap);
      });
      
      // Closing the lightbox
      $theWrap.find('.global-lightbox-close').on('click', function() {
        $('body').removeClass('overflow-hidden');
        $theWrap.removeClass('open');
      });

      $theWrap.on('click', function(e) {
        if ($(e.target).hasClass('global-lightbox-wrap')) {
          $('body').removeClass('overflow-hidden');
          $theWrap.removeClass('open');
        }
      });

      // Previous lightbox item
      $theWrap.find('.global-lightbox-go-prev').on('click', function() {
        if ($theWrap.data('current-index') > 0) {
          $theWrap.data('current-index', $theWrap.data('current-index') - 1);
          setLightboxImage($theWrap);
        }
      });
      
      // Next lightbox item
      $theWrap.find('.global-lightbox-go-next').on('click', function() {
        if ($theWrap.data('current-index') < $theWrap.data('max-index')) {
          $theWrap.data('current-index', $theWrap.data('current-index') + 1);
          setLightboxImage($theWrap);
        }
      });
    })

    // Lightbox triggers. Open the specific lightbox or a generic one.
    if ($lightboxTriggers.length > 0) {
      $lightboxTriggers.each(function() {
        $(this).on('click', function() {
          const index = $(this).data('image-index');

          if ($(this).data('opens')) {
            // Open the specific lightbox
            const lightboxId = $(this).data('opens');
            const $theLightbox = $(`.global-lightbox-wrap[data-lightbox-id="${lightboxId}"]`);
            $theLightbox.data('current-index', index);

            openLightbox($theLightbox);
          } else {
            // Open the generic lightbox
            $('.global-lightbox-wrap').data('current-index', index);
            openLightbox($('.global-lightbox-wrap'));
          }
        });
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/globalLightbox.js